export default class EditTest {
    constructor(testId, testGroupId, name, description) {
        this.testId = testId;
        this.testGroupId = testGroupId;
        this.name = name;
        this.description = description;
    }
}
